/*
  cart-drawer-note.js

  Order note as a bottom sheet rather than an inline textarea, matching the
  coupon sheet. The note is written with /cart/update.js, so nothing is lost
  if the shopper never reaches checkout, and the trigger switches to
  "Order note added" with a pencil once something is saved.
*/
(function () {
  'use strict';

  function root() {
    return document.querySelector('[data-cdn]');
  }

  function q(sel) {
    var r = root();
    return r ? r.querySelector(sel) : null;
  }

  function setOpen(open) {
    var sheet = q('[data-cdn-sheet]');
    var back = q('[data-cdn-backdrop]');
    if (!sheet || !back) return;

    sheet.hidden = !open;
    back.hidden = !open;
    document.documentElement.classList.toggle('cdn-open', open);

    if (open) {
      var input = q('[data-cdn-input]');
      if (input) {
        setTimeout(function () {
          input.focus();
          /* Caret at the end, not over the existing text. */
          input.setSelectionRange(input.value.length, input.value.length);
        }, 60);
      }
    } else {
      showMsg('', null);
    }
  }

  function showMsg(text, kind) {
    var m = q('[data-cdn-msg]');
    if (!m) return;
    if (!text) {
      m.hidden = true;
      m.textContent = '';
      return;
    }
    m.textContent = text;
    m.className = 'cdc__msg is--' + (kind || 'note');
    m.hidden = false;
  }

  function reflect(note) {
    var r = root();
    if (!r) return;
    var btn = r.querySelector('[data-cdn-open]');
    var label = r.querySelector('[data-cdn-label]');
    var del = r.querySelector('[data-cdn-delete]');
    var filled = !!(note && note.trim());

    if (btn) btn.classList.toggle('is--filled', filled);
    if (label) {
      label.textContent = filled
        ? r.getAttribute('data-label-filled')
        : r.getAttribute('data-label-empty');
    }
    /* Nothing stored means nothing to delete. */
    if (del) del.hidden = !filled;
  }

  function wipe() {
    var input = q('[data-cdn-input]');
    var del = q('[data-cdn-delete]');
    if (del) { del.disabled = true; del.classList.add('is--busy'); }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: '' })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (input) input.value = '';
        reflect(cart.note);
        setOpen(false);
      })
      .catch(function () {
        showMsg(root().getAttribute('data-msg-error') || 'Could not remove your note. Please try again.', 'err');
      })
      .finally(function () {
        if (del) { del.disabled = false; del.classList.remove('is--busy'); }
      });
  }

  function save() {
    var input = q('[data-cdn-input]');
    var btn = q('[data-cdn-save]');
    if (!input) return;

    var note = input.value;
    if (btn) { btn.disabled = true; btn.classList.add('is--busy'); }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: note })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        reflect(cart.note);
        setOpen(false);
      })
      .catch(function () {
        showMsg(root().getAttribute('data-msg-error') || 'Could not save your note. Please try again.', 'err');
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('is--busy'); }
      });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-cdn-open]')) { e.preventDefault(); setOpen(true); return; }
    if (e.target.closest('[data-cdn-close]') || e.target.closest('[data-cdn-backdrop]')) {
      e.preventDefault();
      setOpen(false);
      return;
    }
    if (e.target.closest('[data-cdn-save]')) { e.preventDefault(); save(); return; }
    if (e.target.closest('[data-cdn-delete]')) { e.preventDefault(); wipe(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.documentElement.classList.contains('cdn-open')) {
      setOpen(false);
      e.stopPropagation();
    }
    /* Cmd/Ctrl+Enter saves, like most comment boxes. */
    if (e.key === 'Enter' && (e.metaKey || e.ctrlKey) && e.target.matches('[data-cdn-input]')) {
      e.preventDefault();
      save();
    }
  });

  /* The drawer can be re-rendered underneath us; re-read the cart so the
     trigger label always matches what Shopify holds. */
  function sync() {
    if (!root()) return;
    fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { reflect(c.note); })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  document.addEventListener('shopify:section:load', sync);
})();
